// Simplified mock data
export const translations = {
  en: {
    nav_home: 'Home',
    nav_about: 'About',
    nav_team: 'Our Team',
    nav_practice: 'Practice Areas',
    nav_achievements: 'Achievements',
    nav_contact: 'Contact',
    nav_consultation: 'Book Consultation',
    free_consultation: 'FREE CONSULTATION AVAILABLE',
    free_consultation_short: 'Free',
    consultation_word: 'Consultation',
    no_obligation: 'No Obligation',
    confidential: 'Confidential',
    professional_advice: 'Professional Advice',
    hero_title: 'Pathan & Associates',
    hero_subtitle: 'Advocate Imran Pathan',
    hero_designation: 'High Court Advocate',
    hero_description: 'Providing professional legal services with dedication, integrity, and confidentiality. Over 10 years of experience in serving justice.',
    hero_cta: 'Schedule Consultation',
    hero_learn_more: 'Learn More',
    about_title: 'About Advocate Imran Pathan',
    about_welcome: 'Welcome to the official website of Advocate Imran Pathan. This platform is created for legal awareness and general information purposes.',
    about_experience: '10+ Years Experience',
    about_cases: '500+ Cases Handled',
    about_clients: 'Trusted by Hundreds',
    about_intro_title: 'Professional Background',
    about_intro: 'Advocate Imran Pathan is an experienced High Court Advocate with over 10 years of practical legal experience. Every case is handled with dedication, integrity, and confidentiality based on its legal merit and facts.',
    about_qualification_title: 'Qualifications & Registration',
    about_affiliation_title: 'Professional Affiliations',
    mission_title: 'Mission',
    mission_text: 'To ensure easy access to justice in society through accurate legal knowledge and ethical legal services.',
    vision_title: 'Vision',
    vision_text: 'To create a legal environment where people understand their rights and are aware of the law.',
    team_title: 'Our Associates',
    team_subtitle: 'Experienced legal professionals dedicated to serving justice',
    free_legal_aid_title: 'Free Legal Aid / Bonafide Cases',
    free_legal_aid_description: 'Pathan & Associates is committed to providing free legal assistance to economically disadvantaged and underprivileged individuals. If you are unable to afford legal fees, we offer pro bono services for bonafide cases.',
    justice_quote: 'Justice should be accessible to everyone.',
    pro_bono: 'Pro Bono Services',
    pro_bono_desc: 'Free legal representation for eligible cases',
    underprivileged: 'For Underprivileged',
    underprivileged_desc: 'Supporting economically disadvantaged individuals',
    bonafide_cases: 'Bonafide Cases',
    bonafide_cases_desc: 'Genuine cases with legal merit',
    contact_for_aid: 'Contact us to discuss your case and eligibility for free legal aid.',
    apply_bonafide: 'Apply for Free Legal Aid',
    practice_title: 'Practice Areas & Services',
    practice_subtitle: 'Comprehensive legal services across multiple domains',
    achievements_title: 'Recognition & Achievements',
    achievements_subtitle: 'Honored for contributions to legal profession and society',
    achievement_bar_council: 'Bar Council Felicitation',
    achievement_bar_council_desc: 'Felicitation of Mr. Shiv Kishore Gaur on being elected President, Bar Council – Uttar Pradesh',
    achievement_dm: 'District Magistrate Honor',
    achievement_dm_desc: 'Felicitation of Mr. Sanjeev Ranjan on assuming charge as District Magistrate, Aligarh',
    achievement_sir_syed: 'Legal Awareness Contribution',
    achievement_sir_syed_desc: 'Felicitation by Sir Syed Classes for contribution to legal awareness and youth motivation',
    achievement_community: 'Community Service',
    achievement_community_desc: 'Active participation in community legal awareness programs and youth motivation initiatives',
    consultation_title: 'Book a Consultation',
    consultation_subtitle: 'Fill out the form below and we will get back to you shortly',
    online_payment: 'Online Payment Accepted',
    payment_note: 'Initial consultation is FREE. For further professional services, payments can be made online.',
    bank_transfer: 'Bank Transfer',
    form_name: 'Full Name',
    form_email: 'Email Address',
    form_phone: 'Phone Number',
    form_case_type: 'Case Type',
    form_case_type_placeholder: 'Select case type',
    form_message: 'Brief Description',
    form_submit: 'Submit Request',
    form_submitting: 'Submitting...',
    form_success: 'Thank you! We will contact you soon.',
    contact_title: 'Contact Information',
    contact_subtitle: 'Get in touch for legal assistance',
    contact_phone: 'Phone',
    contact_whatsapp: 'WhatsApp',
    contact_email: 'Email',
    contact_office_allahabad: 'High Court Office - Prayagraj',
    contact_office_aligarh: 'District Court Office - Aligarh',
    footer_text: 'Professional Legal Services with Integrity and Dedication',
    footer_copyright: '© 2025 Pathan & Associates. All rights reserved.'
  },
  hi: {
    nav_home: 'मुख्य पृष्ठ',
    nav_about: 'परिचय',
    nav_team: 'हमारी टीम',
    nav_practice: 'सेवाएं',
    nav_achievements: 'उपलब्धियां',
    nav_contact: 'संपर्क',
    nav_consultation: 'परामर्श बुक करें',
    free_consultation: 'मुफ्त परामर्श उपलब्ध',
    free_consultation_short: 'मुफ्त',
    consultation_word: 'परामर्श',
    no_obligation: 'कोई बाध्यता नहीं',
    confidential: 'गोपनीय',
    professional_advice: 'पेशेवर सलाह',
    hero_title: 'पठान एंड एसोसिएट्स',
    hero_subtitle: 'अधिवक्ता इमरान पठान',
    hero_designation: 'उच्च न्यायालय अधिवक्ता',
    hero_description: '10 वर्षों से अधिक के अनुभव के साथ समर्पण और ईमानदारी के साथ कानूनी सेवाएं।',
    hero_cta: 'परामर्श निर्धारित करें',
    hero_learn_more: 'और जानें',
    about_title: 'अधिवक्ता इमरान पठान के बारे में',
    about_welcome: 'अधिवक्ता इमरान पठान की आधिकारिक वेबसाइट में आपका स्वागत है।',
    about_experience: '10+ वर्षों का अनुभव',
    about_cases: '500+ मामले निपटाए',
    about_clients: 'सैकड़ों द्वारा विश्वसनीय',
    about_intro_title: 'व्यावसायिक पृष्ठभूमि',
    about_intro: 'अधिवक्ता इमरान पठान 10 वर्षों से अधिक के अनुभव के साथ उच्च न्यायालय अधिवक्ता हैं।',
    about_qualification_title: 'शैक्षणिक योग्यता और पंजीकरण',
    about_affiliation_title: 'व्यावसायिक संबद्धता',
    mission_title: 'उद्देश्य',
    mission_text: 'सटीक कानूनी ज्ञान के माध्यम से न्याय तक आसान पहुंच।',
    vision_title: 'दृष्टि',
    vision_text: 'कानूनी जागरूकता बढ़ाना जहां लोग अपने अधिकारों को समझें।',
    team_title: 'हमारे सहयोगी',
    team_subtitle: 'न्याय की सेवा के लिए समर्पित अनुभवी कानूनी पेशेवर',
    free_legal_aid_title: 'मुफ्त कानूनी सहायता / बोनाफाइड मामले',
    free_legal_aid_description: 'पठान एंड एसोसिएट्स आर्थिक रूप से वंचित और कमजोर व्यक्तियों को मुफ्त कानूनी सहायता प्रदान करने के लिए प्रतिबद्ध है। यदि आप कानूनी शुल्क वहन करने में असमर्थ हैं, तो हम बोनाफाइड मामलों के लिए प्रो बोनो सेवाएं प्रदान करते हैं।',
    justice_quote: 'न्याय सभी के लिए सुलभ होना चाहिए।',
    pro_bono: 'प्रो बोनो सेवाएं',
    pro_bono_desc: 'योग्य मामलों के लिए मुफ्त कानूनी प्रतिनिधित्व',
    underprivileged: 'वंचितों के लिए',
    underprivileged_desc: 'आर्थिक रूप से कमजोर व्यक्तियों का समर्थन',
    bonafide_cases: 'बोनाफाइड मामले',
    bonafide_cases_desc: 'कानूनी योग्यता वाले वास्तविक मामले',
    contact_for_aid: 'अपने मामले और मुफ्त कानूनी सहायता की पात्रता पर चर्चा के लिए हमसे संपर्क करें।',
    apply_bonafide: 'मुफ्त कानूनी सहायता के लिए आवेदन करें',
    practice_title: 'अभ्यास क्षेत्र और सेवाएं',
    practice_subtitle: 'विभिन्न डोमेन में व्यापक कानूनी सेवाएं',
    achievements_title: 'मान्यता और उपलब्धियां',
    achievements_subtitle: 'कानूनी पेशे और समाज में योगदान',
    achievement_bar_council: 'बार काउंसिल सम्मान',
    achievement_bar_council_desc: 'बार काउंसिल अध्यक्ष चुनाव पर सम्मान',
    achievement_dm: 'जिलाधिकारी सम्मान',
    achievement_dm_desc: 'जिलाधिकारी पदभार पर सम्मान',
    achievement_sir_syed: 'कानूनी जागरूकता',
    achievement_sir_syed_desc: 'युवा प्रेरणा में योगदान',
    achievement_community: 'सामुदायिक सेवा',
    achievement_community_desc: 'कानूनी जागरूकता पहल',
    consultation_title: 'परामर्श बुक करें',
    consultation_subtitle: 'फॉर्म भरें और हम आपसे संपर्क करेंगे',
    online_payment: 'ऑनलाइन भुगतान स्वीकृत',
    payment_note: 'प्रारंभिक परामर्श मुफ्त है। आगे की पेशेवर सेवाओं के लिए ऑनलाइन भुगतान किया जा सकता है।',
    bank_transfer: 'बैंक ट्रांसफर',
    form_name: 'पूरा नाम',
    form_email: 'ईमेल पता',
    form_phone: 'फोन नंबर',
    form_case_type: 'मामले का प्रकार',
    form_case_type_placeholder: 'मामले का प्रकार चुनें',
    form_message: 'संक्षिप्त विवरण',
    form_submit: 'अनुरोध सबमिट करें',
    form_submitting: 'सबमिट हो रहा है...',
    form_success: 'धन्यवाद! हम जल्द ही आपसे संपर्क करेंगे।',
    contact_title: 'संपर्क जानकारी',
    contact_subtitle: 'कानूनी सहायता के लिए संपर्क करें',
    contact_phone: 'फोन',
    contact_whatsapp: 'व्हाट्सएप',
    contact_email: 'ईमेल',
    contact_office_allahabad: 'उच्च न्यायालय कार्यालय',
    contact_office_aligarh: 'जिला न्यायालय कार्यालय',
    footer_text: 'ईमानदारी और समर्पण के साथ कानूनी सेवाएं',
    footer_copyright: '© 2025 पठान एसोसिएट्स।'
  }
};

export const caseTypes = [
  'Criminal Law',
  'Civil Litigation',
  'Family & Matrimonial',
  'Property Disputes',
  'Banking & Finance',
  'Cheque Bounce',
  'Consumer Protection',
  'Cyber Crime',
  'DRT/SARFAESI/RERA',
  'Legal Drafting',
  'Other'
];

export const contactInfo = {
  phones: ['+91 83075 34087', '+91 95361 02786'],
  whatsapp: '+91 83075 34087',
  emails: ['advimranaligarh@gmail.com', 'imran@advocateimranpathan.com']
};
